module.exports = __webpack_public_path__ + "static/img/5_2_1.838ec496.jpg";